export default __webpack_public_path__ + "static/media/palm.faf45180.svg";